import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ApiListSettingsResponse200Type } from 'src/api_openapi/v2/settingsService/apiListSettings';
import { useCommon } from 'src/AppState/Common';
import { ConfigurationManagerState } from 'src/domains/layouts/webview/ConfigurationManager/configurationManager.state';
import {
    ListItem,
    ServiceSettingsHeader,
    ServiceSettingsListContainer,
} from 'src/domains/layouts/webview/ConfigurationManager/serviceSettingsList/serviceSettingsList.style';

type ServiceSettingsPropsType = {
    service: ApiListSettingsResponse200Type['data'][number];
};

export const ServiceSettingsList = observer(
    'ServiceSettings',
    (props: ServiceSettingsPropsType): React.ReactElement => {
        const common = useCommon();
        const state = ConfigurationManagerState.get(common);

        return (
            <ServiceSettingsListContainer>
                <ListItem>
                    <ServiceSettingsHeader onClick={() => state.setCurrentServiceId(props.service.id)}>
                        {props.service.name}
                        {/*<ServiceSettingsDecription>{props.service.schema.description}</ServiceSettingsDecription>*/}
                    </ServiceSettingsHeader>
                </ListItem>
            </ServiceSettingsListContainer>
        );
    }
);
